// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const logot = {
  logoBeige: asset("1577195034-logo-beige.svg", {
    alt: " ",
  }),
  logoValkoinen: asset("1577194809-logo-white.svg", {
    alt: " ",
  }),
  logoGold: asset("1577786092-logo-gold.svg", {
    alt: " ",
  }),
};

const sivusto = {
  tausta2: asset("1577112007-netblue.svg"),
  tausta3: asset("1614330594-netlightblue.svg"),
  tausta4: asset("1577382790-blue-net-526x482.svg", {
    alt: "Uniikki tilasuunnittelu tausta",
  }),
  tausta1: asset("1577112008-netgold.svg"),
};

const contact = {
  title: "Ota yhteyttä, kun etsit modernia toimitilaa erinomaisilla kulkuyhteyksillä.",
  imgMap: asset("1577112833-esteri-karttakuva-1000x1000-v2.jpg", {
    alt: "Ester1 kartta",
    sizes: "(max-width: 900px) 100vw, 900px",
    aspectRatio: 1,
  }),
  contactPersonText: "<h3>Asiakkuusp&auml;&auml;llikk&ouml;</h3>\n<p>Valtteri Arvonen<br />+358 400 17 6526<br />valtteri.arvonen@kansallis.fi</p>",
  huolto: "<h3>Huolto- ja kiinteist&ouml;palvelu</h3>\n<p>Kotikatu Pasila<br />Asiakaspalvelu 07.00&ndash;16.00<br />010 270 8620</p>\n<p>P&auml;ivystys 16.00&ndash;07.00<br />010 270 8888</p>\n<p>pasila@kotikatu.fi</p>\n<p></p>",
  palvelupyyntUrl: "https://request.granlundmanager.fi/?id=4URKgvedQLUTPK9a1kvvz30kUWKkvu486gPV%2fcrl75Nd9l6t%2fSsUA6J%2f4hg3M5rsr0zFEGlMrgWIC52RDq7xY7bd1FVD8kKJ75hPn4kXvPo%3d",
  vuokranantaja: "<h3>Kiinteist&ouml;p&auml;&auml;llikk&ouml;</h3>\n<p>Jaakko Laaksonen<br />+358 44 3422 095<br />jaakko.laaksonen@kansallis.fi</p>\n<p></p>\n<p></p>\n<p></p>\n<p></p>\n<p></p>\n<p></p>",
  tietosuojaseloste: "<h1>Tietosuojaseloste</h1>\n<p>1. Rekisterinpit&auml;j&auml;<br />KOy Esterinportti 1<br />Y-tunnus: 2906887-7<br />Linnankatu 20 A 1, <br />20100 TURKU</p>\n<p>2. Rekisterist&auml; vastaava yhteyshenkil&ouml;<br />Markus Palmroth<br />markus.palmroth@kansallis.fi</p>\n<p>3. Rekisterin nimi<br />Verkkopalvelun k&auml;ytt&auml;j&auml;rekisteri ja markkinointirekisteri</p>\n<p>4. Oikeusperuste ja henkil&ouml;tietojen k&auml;sittelyn tarkoitus<br />EU:n yleisen tietosuoja-asetuksen mukainen oikeusperuste henkil&ouml;tietojen k&auml;sittelylle on verkkosivujen k&auml;ytt&ouml;ehtojen hyv&auml;ksyminen. Henkil&ouml;tietojen k&auml;sittelyn tarkoitus on verkkopalvelun yhteydenpito asiakkaisiin, asiakassuhteen yll&auml;pito sek&auml; suoramarkkinointi. Tietoja ei k&auml;ytet&auml; automatisoituun p&auml;&auml;t&ouml;ksentekoon tai profilointiin.</p>\n<p>5. Rekisterin tietosis&auml;lt&ouml;<br />Rekisteriin tallennettavia tietoja ovat:<br />henkil&ouml;n nimi, yhteystiedot (puhelinnumero, s&auml;hk&ouml;postiosoite, osoite), www-sivustojen osoitteet, verkkoyhteyden IP-osoite, tunnukset/profiilit sosiaalisen median palveluissa, tiedot tilatuista palveluista ja niiden muutoksista, laskutustiedot, muut asiakassuhteeseen ja tilattuihin palveluihin liittyv&auml;t tiedot.</p>\n<p>6. S&auml;&auml;nn&ouml;nmukaiset tietol&auml;hteet<br />Rekisteriin tallennettavat tiedot saadaan asiakkaalta mm. www-lomakkeilla l&auml;hetetyist&auml; viesteist&auml;, s&auml;hk&ouml;postitse, puhelimitse, sosiaalisen median palvelujen kautta, sopimuksista, asiakastapaamisista ja muista tilanteista, joissa asiakas luovuttaa tietojaan.</p>\n<p>7. Tietojen s&auml;&auml;nn&ouml;nmukaiset luovutukset ja tietojen siirto EU:n tai ETA:n ulkopuolelle<br />Tietoja ei luovuteta s&auml;&auml;nn&ouml;nmukaisesti muille tahoille. Tietoja voidaan julkaista silt&auml; osin kuin niin on sovittu asiakkaan kanssa. <span>Tietoja ei P&auml;&auml;s&auml;&auml;nt&ouml;isesti luovuteta EU:n tai ETA-alueen ulkopuolelle. Joissakin tapauksissa k&auml;ytt&auml;m&auml;mme pilvipalveluiden palvelimet sijaitsevat EU:n tai ETA-alueen ulkopuolella.</span></p>\n<p>8. Rekisterin suojauksen periaatteet<br />Rekisterin k&auml;sittelyss&auml; noudatetaan huolellisuutta ja tietoj&auml;rjestelmien avulla k&auml;sitelt&auml;v&auml;t tiedot suojataan asianmukaisesti. Kun rekisteritietoja s&auml;ilytet&auml;&auml;n Internet-palvelimilla, niiden laitteiston fyysisest&auml; ja digitaalisesta tietoturvasta huolehditaan asiaankuuluvasti. Rekisterinpit&auml;j&auml; huolehtii siit&auml;, ett&auml; tallennettuja tietoja sek&auml; palvelimien k&auml;ytt&ouml;oikeuksia ja muita henkil&ouml;tietojen turvallisuuden kannalta kriittisi&auml; tietoja k&auml;sitell&auml;&auml;n luottamuksellisesti ja vain niiden ty&ouml;ntekij&ouml;iden toimesta, joiden ty&ouml;nkuvaan se kuuluu.</p>\n<p>9. Tarkastusoikeus ja oikeus vaatia tiedon korjaamista<br />Jokaisella rekisteriss&auml; olevalla henkil&ouml;ll&auml; on oikeus tarkistaa rekisteriin tallennetut tietonsa ja vaatia mahdollisen virheellisen tiedon korjaamista tai puutteellisen tiedon t&auml;ydent&auml;mist&auml;. Mik&auml;li henkil&ouml; haluaa tarkistaa h&auml;nest&auml; tallennetut tiedot tai vaatia niihin oikaisua, pyynt&ouml; tulee l&auml;hett&auml;&auml; kirjallisesti rekisterinpit&auml;j&auml;lle. Rekisterinpit&auml;j&auml; voi pyyt&auml;&auml; tarvittaessa pyynn&ouml;n esitt&auml;j&auml;&auml; todistamaan henkil&ouml;llisyytens&auml;. Rekisterinpit&auml;j&auml; vastaa asiakkaalle EU:n tietosuoja-asetuksessa s&auml;&auml;detyss&auml; ajassa (p&auml;&auml;s&auml;&auml;nt&ouml;isesti kuukauden kuluessa).</p>\n<p>10. Muut henkil&ouml;tietojen k&auml;sittelyyn liittyv&auml;t oikeudet<br />Rekisteriss&auml; olevalla henkil&ouml;ll&auml; on oikeus pyyt&auml;&auml; h&auml;nt&auml; koskevien henkil&ouml;tietojen poistamiseen rekisterist&auml; (&rdquo;oikeus tulla unohdetuksi&rdquo;). Niin ik&auml;&auml;n rekister&ouml;idyill&auml; on muut EU:n yleisen tietosuoja-asetuksen mukaiset oikeudet kuten henkil&ouml;tietojen k&auml;sittelyn rajoittaminen tietyiss&auml; tilanteissa. Pyynn&ouml;t tulee l&auml;hett&auml;&auml; kirjallisesti rekisterinpit&auml;j&auml;lle. Rekisterinpit&auml;j&auml; voi pyyt&auml;&auml; tarvittaessa pyynn&ouml;n esitt&auml;j&auml;&auml; todistamaan henkil&ouml;llisyytens&auml;. Rekisterinpit&auml;j&auml; vastaa asiakkaalle EU:n tietosuoja-asetuksessa s&auml;&auml;detyss&auml; ajassa (p&auml;&auml;s&auml;&auml;nt&ouml;isesti kuukauden kuluessa).</p>\n<p></p>",
  vuokralainenOtsikko: "Yhteystiedot vuokralaiselle",
  image: asset("1655981672-yleiset-tilat-10-web.jpg", {
    sizes: "(max-width: 2100px) 100vw, 2100px",
    aspectRatio: 4.718033,
  }),
};

const lataaEsite = {
  otsikko: "Lataa Ester1-toimitilojen kohde- ja sisustusesite",
  teksti: "Lataa kohde- ja sisustusesitteet PDF-muodossa. Tutustu Ester1:n tarjoamiin ratkaisuihin tarkemmin ja sukella sisustustyyleihin yksityiskohtaisesti.",
  esite: asset("1645709507-ester1-esite2022.pdf"),
  esite2: asset("1615886462-ester1toimistotsisustustyylikooste090420.pdf"),
};

const highlight = {
  goodPoints: [
    {
      id: "DatoCmsGoodPointItem-2021649-fi",
      text: "10–150 hengen yrityksille",
      iconDark: asset("1577112512-i-people-blue.svg"),
      iconLight: asset("1577112513-i-people.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021650-fi",
      text: "Kulunvalvonta ja kameravalvonta",
      iconDark: asset("1614959224-i-lukko-tumma.svg"),
      iconLight: asset("1614959229-i-lukko-vaalea.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021651-fi",
      text: "Autopaikat ja sähköauton lataus",
      iconDark: asset("1577112499-i-battery-blue.svg"),
      iconLight: asset("1577112499-i-battery.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021653-fi",
      text: "Pyöräparkki",
      iconDark: asset("1577112500-i-bike-blue.svg"),
      iconLight: asset("1577112501-i-bike.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021654-fi",
      text: "Suihkut ja lukittavat säilytyskaapit",
      iconDark: asset("1577112514-i-shower-blue.svg"),
      iconLight: asset("1577112514-i-shower.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021655-fi",
      text: "Ympäristöystävälliset ja -sertifioidut tilat",
      iconDark: asset("1577112517-i-sun-blue.svg"),
      iconLight: asset("1577112518-i-sunrise.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021656-fi",
      text: "Supernopeat valokuituyhteydet",
      iconDark: asset("1577112508-i-electricity-blue.svg"),
      iconLight: asset("1577112508-i-electricity.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021657-fi",
      text: "Moderni ja tehokas ilmanvaihto",
      iconDark: asset("1577112511-i-panel-blue.svg"),
      iconLight: asset("1577112512-i-panel.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021658-fi",
      text: "Erinomainen sisäilma",
      iconDark: asset("1577112496-i-air-blue.svg"),
      iconLight: asset("1577112497-i-air.svg"),
    },
    {
      id: "DatoCmsGoodPointItem-2021659-fi",
      text: "Vettä säästävät hanat",
      iconDark: asset("1577112519-i-water-blue.svg"),
      iconLight: asset("1577112521-i-water-tap.svg"),
    },
  ],
  kuvagalleria: [
    {
      image: asset("1655981658-julkisivu-4-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 5,
      height: 2,
    },
    {
      image: asset("1655981665-julkisivu-2-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 7,
      height: 4,
    },
    {
      image: asset("1655981672-yleiset-tilat-10-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 7,
      height: 4,
    },
    {
      image: asset("1655981680-yleiset-tilat-11-web.jpg", {
        width: 675,
        height: 1013,
      }),
      width: 5,
      height: 2,
    },
    {
      image: asset("1655981687-yleiset-tilat-12-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 1,
      height: 1,
    },
    {
      image: asset("1655981694-yleiset-tilat-13-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 1,
      height: 1,
    },
    {
      image: asset("1655981700-yleiset-tilat-14-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 1,
      height: 1,
    },
    {
      image: asset("1655981707-toimitilat-9-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 5,
      height: 2,
    },
    {
      image: asset("1655981711-toimitilat-26-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 7,
      height: 4,
    },
    {
      image: asset("1655981721-toimitilat-38-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 7,
      height: 4,
    },
    {
      image: asset("1655981731-toimitilat-31-web.jpg", {
        width: 1200,
        height: 675,
      }),
      width: 5,
      height: 2,
    },
  ],
};

module.exports = { logot, sivusto, contact, lataaEsite, highlight };
